import { useEffect } from "react";
import type { CharacterAssetRecord } from "@apis/http/api";

const POLL_INTERVAL_MS = 5000;

/**
 * Characters Tab 的 ModelArk 绑定状态轮询。
 *
 * 创建角色后后端异步发起 ModelArk 绑定，需要前端拉详情/列表才能感知 BOUND/FAILED。
 * 简化策略：列表里只要还有 `BINDING` 状态的角色，就每 5s 拉一次列表；全部 BOUND/FAILED
 * 后停止。当列表为空或 Tab 离开时也立刻停止。
 *
 * @param items   当前 character 列表（取自 useLibraryCards）
 * @param refresh 列表刷新方法（同 hook 提供）
 * @param enabled 是否启用（一般绑定 focusType === 'character'）
 */
export const useCharacterBindingPoll = (items: CharacterAssetRecord[], refresh: () => void, enabled: boolean) => {
  const hasBinding = enabled && items.some((item) => item.bindState === "BINDING");

  useEffect(() => {
    if (!hasBinding) return undefined;
    const timer = setInterval(refresh, POLL_INTERVAL_MS);
    return () => clearInterval(timer);
  }, [hasBinding, refresh]);
};
